import React, { FC, ReactNode } from 'react';
import { Box, media, xcss } from '@atlaskit/primitives';

const accordionSectionStyles = xcss({
  paddingBottom: 'space.300',
  [media.above.xs]: {
    paddingBottom: 'space.600',
  },
});

const accordionHeaderStyles = xcss({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  paddingBottom: 'space.200',
  gap: 'space.100',
});

export interface AccordionSectionProps {
  isOpen: boolean;
  showMarker: boolean;
  title: ReactNode;
  onClick: () => void;
  children?: ReactNode;
}

const AccordionSection: FC<AccordionSectionProps> = ({ isOpen, showMarker, title, onClick, children }) => {
  return (
    <Box xcss={accordionSectionStyles}>
      <Box xcss={accordionHeaderStyles} testId='accordion-section-header' onClick={onClick}>
        {title}
        {showMarker && (
          <Box testId='accordion-section-marker'>{isOpen ? <span>&#9660;</span> : <span>&#9650;</span>}</Box>
        )}
      </Box>
      {isOpen && <section data-testid='accordion-section-content'>{children}</section>}
    </Box>
  );
};

export default AccordionSection;
